(() => {
  "use strict";

  /* =========================================
     Monello Erinnerungsbegleiter – Version 2
     Nur für Produktseiten
     ========================================= */

  const MONELLO_TEXTE = {
    liebe: [
      "Für immer geliebt",
      "Für immer im Herzen",
      "Für immer bei mir",
      "Unendlich geliebt",
      "Mein größtes Glück",
      "Mein Seelentier",
      "Immer an meiner Seite",
      "Für immer verbunden"
    ],

    erinnerung: [
      "Unvergessen",
      "In lieber Erinnerung",
      "Für immer nah",
      "Im Herzen vereint",
      "Deine Liebe bleibt",
      "Immer bei uns",
      "Im Herzen zuhause",
      "Du bleibst unvergessen"
    ],

    hoffnung: [
      "Lauf frei",
      "Für immer frei",
      "Bis zum Wiedersehen",
      "Wir sehen uns wieder",
      "Hinter dem Regenbogen",
      "Auf ewig frei",
      "Flieg in Frieden",
      "Dein Weg geht weiter"
    ],

    dankbarkeit: [
      "Danke für alles",
      "Danke für deine Liebe",
      "Danke für die Zeit",
      "Danke von Herzen",
      "Danke für jeden Tag",
      "Du warst ein Geschenk",
      "Danke mein Freund",
      "Danke für dein Vertrauen"
    ],

    trost: [
      "Du fehlst",
      "Liebe bleibt",
      "In Liebe",
      "Für immer dein",
      "Im Herzen geborgen",
      "Du bleibst bei mir",
      "Für immer eins",
      "Bis wir uns wiedersehen"
    ]
  };

  const KATEGORIEN = {
    liebe: {
      icon: "❤️",
      title: "Liebe",
      description: "Worte tiefer Verbundenheit"
    },

    erinnerung: {
      icon: "🕊",
      title: "Erinnerung",
      description: "Worte, die für immer bleiben"
    },

    hoffnung: {
      icon: "🌈",
      title: "Hoffnung",
      description: "Ein Abschied voller Zuversicht"
    },

    dankbarkeit: {
      icon: "🤍",
      title: "Dankbarkeit",
      description: "Für all die gemeinsame Zeit"
    },

    trost: {
      icon: "✨",
      title: "Trost",
      description: "Wenn wenige Worte viel sagen"
    }
  };

  let activeCategory = null;
  let lastFocusedElement = null;

  function isProductPage() {
    return (
      document.body.classList.contains("template-product") ||
      window.location.pathname.includes("/products/")
    );
  }

  function findErinnerungstextField() {
    const labels = Array.from(
      document.querySelectorAll("label")
    );

    const matchingLabel = labels.find((label) =>
      label.textContent
        ?.trim()
        .toLowerCase()
        .includes("erinnerungstext")
    );

    if (matchingLabel?.htmlFor) {
      const field = document.getElementById(
        matchingLabel.htmlFor
      );

      if (field) return field;
    }

    return (
      document.querySelector(
        'textarea[name*="Erinnerungstext"]'
      ) ||
      document.querySelector(
        'input[name*="Erinnerungstext"]'
      ) ||
      document.getElementById("text-6")
    );
  }

  function getModal() {
    return document.getElementById(
      "monello-gravur-modal"
    );
  }

  function getLauncher() {
    return document.getElementById(
      "monello-gravur-assistent"
    );
  }

  function resetModal() {
    const modal = getModal();
    if (!modal) return;

    activeCategory = null;

    modal
      .querySelectorAll("[data-mga-view]")
      .forEach((view) => {
        view.hidden =
          view.dataset.mgaView !== "categories";
      });

    modal
      .querySelectorAll("[data-mga-category]")
      .forEach((button) => {
        button.classList.remove("is-active");
      });

    const results = modal.querySelector(
      "[data-mga-results]"
    );

    if (results) {
      results.innerHTML = "";
    }

    const backButton = modal.querySelector(
      "[data-mga-back]"
    );

    if (backButton) {
      backButton.hidden = true;
    }

    const stepLabel = modal.querySelector(
      "[data-mga-step-label]"
    );

    if (stepLabel) {
      stepLabel.textContent = "Schritt 1 von 2";
    }
  }

  function openModal() {
    const modal = getModal();
    if (!modal) {
      console.warn(
        "Monello Erinnerungsbegleiter wurde nicht gefunden."
      );
      return;
    }

    lastFocusedElement = document.activeElement;

    resetModal();

    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");

    document.body.classList.add("mga-modal-open");

    window.requestAnimationFrame(() => {
      modal.classList.add("is-open");

      const closeButton = modal.querySelector(
        ".mga-modal__close"
      );

      closeButton?.focus();
    });
  }

  function closeModal() {
    const modal = getModal();
    if (!modal) return;

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");

    document.body.classList.remove("mga-modal-open");

    window.setTimeout(() => {
      modal.hidden = true;
      resetModal();

      if (
        lastFocusedElement &&
        typeof lastFocusedElement.focus === "function"
      ) {
        lastFocusedElement.focus();
      }
    }, 250);
  }

  function showCategories() {
    const modal = getModal();
    if (!modal) return;

    activeCategory = null;

    modal
      .querySelectorAll("[data-mga-view]")
      .forEach((view) => {
        view.hidden =
          view.dataset.mgaView !== "categories";
      });

    const backButton = modal.querySelector(
      "[data-mga-back]"
    );

    if (backButton) {
      backButton.hidden = true;
    }

    const stepLabel = modal.querySelector(
      "[data-mga-step-label]"
    );

    if (stepLabel) {
      stepLabel.textContent = "Schritt 1 von 2";
    }
  }

  function showTexts(category) {
    const modal = getModal();
    if (!modal) return;

    const texts = MONELLO_TEXTE[category] || [];
    const categoryData = KATEGORIEN[category];

    activeCategory = category;

    modal
      .querySelectorAll("[data-mga-view]")
      .forEach((view) => {
        view.hidden =
          view.dataset.mgaView !== "texts";
      });

    const heading = modal.querySelector(
      "[data-mga-results-title]"
    );

    if (heading && categoryData) {
      heading.textContent =
        `${categoryData.icon} ${categoryData.title}`;
    }

    const results = modal.querySelector(
      "[data-mga-results]"
    );

    if (!results) return;

    results.innerHTML = "";

    texts.forEach((text) => {
      const button = document.createElement("button");

      button.type = "button";
      button.className = "mga-text-choice";
      button.dataset.mgaUseText = text;

      const icon = document.createElement("span");
      icon.className = "mga-text-choice__icon";
      icon.setAttribute("aria-hidden", "true");
      icon.textContent = "🤍";

      const textElement = document.createElement("span");
      textElement.className = "mga-text-choice__text";
      textElement.textContent = text;

      button.append(icon, textElement);
      results.appendChild(button);
    });

    const backButton = modal.querySelector(
      "[data-mga-back]"
    );

    if (backButton) {
      backButton.hidden = false;
    }

    const stepLabel = modal.querySelector(
      "[data-mga-step-label]"
    );

    if (stepLabel) {
      stepLabel.textContent = "Schritt 2 von 2";
    }
  }

  function useText(text) {
    const textField = findErinnerungstextField();

    if (!textField) {
      console.warn(
        "Das Feld für den Erinnerungstext wurde nicht gefunden."
      );
      return;
    }

    textField.value = text;

    textField.dispatchEvent(
      new Event("input", {
        bubbles: true
      })
    );

    textField.dispatchEvent(
      new Event("change", {
        bubbles: true
      })
    );

    closeModal();

    window.setTimeout(() => {
      textField.focus();
    }, 280);
  }

function createLauncher() {
  /*
   * Der Assistent wird jetzt als bedingtes HTML-Element
   * direkt von Globo ausgegeben.
   */
  return getLauncher();
}

  function handleClick(event) {
    const openButton = event.target.closest(
      "[data-mga-open]"
    );

    if (openButton) {
      event.preventDefault();
      openModal();
      return;
    }

    const closeButton = event.target.closest(
      "[data-mga-close]"
    );

    if (closeButton) {
      event.preventDefault();
      closeModal();
      return;
    }

    const backButton = event.target.closest(
      "[data-mga-back]"
    );

    if (backButton) {
      event.preventDefault();
      showCategories();
      return;
    }

    const categoryButton = event.target.closest(
      "#monello-gravur-modal [data-mga-category]"
    );

    if (categoryButton) {
      event.preventDefault();

      showTexts(
        categoryButton.dataset.mgaCategory
      );

      return;
    }

    const textButton = event.target.closest(
      "#monello-gravur-modal [data-mga-use-text]"
    );

    if (textButton) {
      event.preventDefault();

      useText(
        textButton.dataset.mgaUseText
      );
    }
  }

  function handleKeydown(event) {
    if (event.key !== "Escape") return;

    const modal = getModal();

    if (modal && !modal.hidden) {
      closeModal();
    }
  }

function initialize() {
  if (!isProductPage()) return;

  createLauncher();
}

document.addEventListener("click", handleClick);

  document.addEventListener(
    "keydown",
    handleKeydown
  );

  document.addEventListener(
    "DOMContentLoaded",
    initialize
  );

  [400, 900, 1600, 2800, 4500].forEach(
    (delay) => {
      window.setTimeout(initialize, delay);
    }
  );

  window.MonelloErinnerungsbegleiter = {
    open: openModal,
    close: closeModal,
    texts: MONELLO_TEXTE
  };
})();